export const gdpr = {
  routes: [
    {
      path: "/data-datasubject/:data",
      component: () => import("../organization-data-datasubject-view"),
    },
  ],
};
